module.exports = __webpack_public_path__ + "img/MobilORB_Footer.28c213e7.png";